module.exports = __webpack_public_path__ + "img/floorplans-icon.d689b18e.svg";